// API endpoints
export const API_BASE_URL = "https://api.emboxvn.com";
export const UPLOAD_API_URL = "https://api.emboxvn.com/upload";

// Upload constants
export const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB chunks
export const SINGLE_UPLOAD_LIMIT = 5 * 1024 * 1024; // 5MB limit for single upload

// Pagination constants
export const PAGE_SIZES = [10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;

// Supported file types according to server configuration
export const SUPPORTED_TYPES = {
    IMAGE: ["image/jpeg", "image/png", "image/gif", "image/webp"],
    AUDIO: [
        "audio/wav",
        "audio/mp3",
        "audio/aiff",
        "audio/aac",
        "audio/ogg",
        "audio/flac",
    ],
    VIDEO: [
        "video/mp4",
        "video/webm",
    ],
    DOCUMENT: [
        "application/pdf",
        "text/plain",
        "text/markdown",
        "text/x-markdown",
        "application/x-httpd-php",
        "application/javascript",
        "text/javascript",
        "application/python",
        "text/x-python",
    ],
};

// Flatten all supported types for validation
export const VALID_MIME_TYPES = [
    ...SUPPORTED_TYPES.IMAGE,
    ...SUPPORTED_TYPES.AUDIO,
    ...SUPPORTED_TYPES.VIDEO,
    ...SUPPORTED_TYPES.DOCUMENT
];

// Function to get category of file type
export const getFileTypeCategory = (mimeType) => {
    if (SUPPORTED_TYPES.IMAGE.includes(mimeType)) return 'IMAGE';
    if (SUPPORTED_TYPES.AUDIO.includes(mimeType)) return 'AUDIO';
    if (SUPPORTED_TYPES.VIDEO.includes(mimeType)) return 'VIDEO';
    if (SUPPORTED_TYPES.DOCUMENT.includes(mimeType)) return 'DOCUMENT';
    return 'UNKNOWN';
};

// Valid file name regex pattern (only allows English letters, numbers, - and _)
export const VALID_FILENAME_PATTERN = /^[a-zA-Z0-9_-]+\.[a-zA-Z0-9]+$/;